const days = [];
for (let index = 1; index <= 31; index += 1) {
  const str = index.toString();
  days.push(str.length === 1 ? `0${str}` : str);
}

export default days;
